module.exports = __webpack_public_path__ + "static/oaken_bolter-b32ba7ff2d43352809e9096c14178b73.png";